import { createI18n } from '@app/i18n';
import client from '../assets/translations/en/client.json';
export * from '@app/i18n';

export const supportedLocales = ['en', 'fr', 'es', 'de'];
export const i18n = createI18n('client', { client });
